import { PhaseKind } from './protocols';

export const AURORA = {
  base: '#15112E',
  blobViolet: '#3A2E6E',
  blobBlue: '#1E2A5A',
  blobPlum: '#3A2456',
  textPrimary: '#EDE9FE',
  textSecondary: '#B4A7F0',
  textMuted: '#8B82C0',
  accent: '#8B7FF0', // shared aurora-violet (equals PHASE_ORB.inhale)
};

// Phase → orb colour (aurora family).
export const PHASE_ORB: Record<PhaseKind, string> = {
  inhale: '#8B7FF0',
  holdIn: '#A9A0FF',
  exhale: '#6D6FE0',
  holdOut: '#4B4A9E',
};

export const SETTLE_ORB = '#4B4A9E';

// Mix a #rrggbb hex toward white by amount (0..1). Pure. Returns the input
// unchanged when it is not a 6-digit hex.
export function lighten(hex: string, amount: number): string {
  const m = /^#?([0-9a-fA-F]{6})$/.exec(hex);
  if (!m) return hex;
  const n = parseInt(m[1], 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  const mix = (c: number) => Math.round(c + (255 - c) * amount);
  const to2 = (c: number) => mix(c).toString(16).padStart(2, '0');
  return `#${to2(r)}${to2(g)}${to2(b)}`;
}
